// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {PodcastsScreenLayout} from 'app_components/screens/landing/podcasts'
// @end

// @ADD Component types
interface IPodcastsScreenProps {}
interface IPodcastsScreenState {}

class PodcastsScreen extends Component<IPodcastsScreenProps, IPodcastsScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IPodcastsScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <PodcastsScreenLayout/>
    )
  }
}

export default PodcastsScreen
